import React from 'react';

import { ProgressBar } from 'eymp-uicomps';

import './ProgressBar.scss';

function GlobalProgressBar({ progress }) {
  return (
    <div className="progress-bar ">
      <ProgressBar value={progress} />
    </div>
  );
}

export default GlobalProgressBar;
